import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AppForm } from '../../../common/forms/app.form';
import { SessionService } from '../../../services/ssession.service';
import { CustomValidator } from '../../../common/forms/custom.validators';
import { AttachmentAttachmentRead, IssueReportAppEntityIssueReportWrite } from '../../../openapi';

@Injectable()
export class EApplicationForm extends AppForm {

  public reportCategories: string[] = [
    'Oświetlenie',
    'Wodociągi',
    'Czystość',
    'Drogi',
    'Zwierzęta',
    'Inne'
  ];

  constructor() {
    super({
      reportCategory: new FormControl<any | null>(null, {
        nonNullable: false,
        validators: [Validators.required]
      }),
      notes: new FormControl('', { nonNullable: true, validators: [Validators.maxLength(5000)] }),
      firstName: new FormControl(SessionService.GetTokenData()?.firstName || '', [Validators.required, Validators.maxLength(255)]),
      lastName: new FormControl(SessionService.GetTokenData()?.lastName || '', [Validators.required, Validators.maxLength(255)]),
      email: new FormControl(SessionService.GetTokenData()?.email || '', {
        validators: [
          CustomValidator.email(),
          Validators.maxLength(255)
        ],
        nonNullable: true
      }),
      phone: new FormControl('', {
        validators: [CustomValidator.phone(), Validators.maxLength(255)],
        nonNullable: true
      }),
      regulations: new FormControl(false, { validators: [Validators.requiredTrue], nonNullable: true }),
      clause: new FormControl(false, { validators: [Validators.requiredTrue], nonNullable: true }),
      geometry: new FormControl(null, Validators.required),
      mapImage: new FormControl(null)
    });
  }

  public get photo1(): FormControl | null {
    return this.get('photo1') as FormControl | null;
  }

  public get photo2(): FormControl | null {
    return this.get('photo2') as FormControl | null;
  }

  public get photo3(): FormControl | null {
    return this.get('photo3') as FormControl | null;
  }

  public get mapImage(): FormControl | null {
    return this.get('mapImage') as FormControl | null;
  }

  public get notes(): FormControl {
    return this.get('notes') as FormControl;
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  private get reportCategory(): FormControl {
    return this.get('reportCategory') as FormControl;
  }

  public reportCategoryChange(name: string): void {
    if (name === 'Czystość') {
      this.notes.setValidators([Validators.required, Validators.maxLength(5000)]);
    } else {
      this.notes.setValidators([Validators.maxLength(5000)]);
    }
    this.notes.updateValueAndValidity();

    this.addAttachmentControls(name);
  }

  public addAttachmentControls(v: string): void {
    if (v === 'Czystość') {
      this.addControl(
        'photo1',
        new FormControl<AttachmentAttachmentRead[]>([], {
          validators: [Validators.minLength(1), Validators.required],
          nonNullable: true
        })
      );
      this.addControl(
        'photo2',
        new FormControl<AttachmentAttachmentRead[]>([], {
          validators: [],
          nonNullable: true
        })
      );
      this.addControl(
        'photo3',
        new FormControl<AttachmentAttachmentRead[]>([], {
          validators: [],
          nonNullable: true
        })
      );
    } else {
      this.removeControl('photo1');
      this.removeControl('photo2');
      this.removeControl('photo3');
    }

  }

  public get attachments(): AttachmentAttachmentRead[] {
    let result: AttachmentAttachmentRead[] = [];
    if (this.photo1?.value) {
      result = result.concat(this.photo1?.value);
    }
    if (this.photo2?.value) {
      result = result.concat(this.photo2?.value);
    }
    if (this.photo3?.value) {
      result = result.concat(this.photo3?.value);
    }
    if (this.mapImage?.value) {
      result.push(this.mapImage?.value);
    }
    return result;
  }

  public toReport(): IssueReportAppEntityIssueReportWrite {
    const value = this.value;
    delete value['photo1'];
    delete value['photo2'];
    delete value['photo3'];
    delete value['mapImage'];
    delete value['regulations'];
    delete value['clause'];
    return {
      ...value,
      geometry: JSON.stringify(this.geometry.value),
      description: this.value?.notes || '',
      category: this.reportCategory.value
    };
  }


}
